module.exports =  {

  whatIsMarketplace: {
    title: 'What Is "Marketplace"?',
    contents: `
      <p>Marketplace is the place for token trading. Here you can see open orders,
        create new orders and fill orders. Open orders are listed as trading pairs.
      You can find trading pairs from the "Popular Trading Pairs" section or form the
      "My Watchlist" section, where you can also add new trading pairs.</p>
    `,
  },

  howToAddTradingPair: {
    title: 'How to Add New Trading Pairs?',
    contents: `
      <p>At LedgerDex, we allow trading pairs between any ERC20 tokens. You can add new trading pairs
      by yourself withou asking our permissions.</p>
      <p>To add a new trading pair, you can visit the "Marketplace" page and click the "Add New Trading
      Pair" button under the "My Watchlist" section.</p>
      <p>To add a new trading pair, you can select tokens for buying and selling from the dropdown menu.
      The available tokens listed in the menus include your tracked tokens as well as some popular tokens.
      If you can't find the token you are interested there, you can click on the "+Add New Token"
      link in the menu to add the token. That token will also be added to your token watchlist.</p>
    `,
  },

  howToReadOrders: {
    title: 'How to Read Orders?',
    contents: `
      <p>For each trading pair, you can see two sets of open orders: "Asks" and "Bids". "Asks" are listed
      on the top and "Bids" are listed on the bottom. In the middle, you can also find the spread value
      for the trading pair.</p>
      <p>For example, for the "ZRX - WETH" trading pair, one order set (showing on the top) sells ZRX and buys
       WETH (called "asks"), while the other set (on the bottom) sells WETH and buys ZRX (called "bids").
       Open orders are sorted by their prices. Generally speaking, The ones closer to the middle bar are
       more attractive to fill in terms of price.</p>
      <p>You can fill an open order by clicking on the "fill" buttons. To fill an order, you need to own
      the correspoding token and have set allowance for that token previously.</p>
      <p>You can also create your
      own order (for other traders to fill) by clicking on the "Create Order" button.</p>
    `,
  },

  howToTrade: {
    title: 'How to Trade?',
    contents: `
      <p>Let's say you want to exchange some of your ZRX tokens for some WETH tokens.
      in other words, you want to sell ZRX and buy WETH. You can do this in one of two
      following ways:</p>
      <ul class="mb-2">
        <li><strong>Method 1: find an existing order to fill</strong>: Visit the marketplace page for the "WETH - ZRX" trading pair, which sell WETH and buy ZRX. If you find one open order with a price
          that you are satisfied with, you can fill that order. In this case, you are the
          <strong>taker</strong> of this trade.</li>
        <li><strong>Method 2: create a new order and wait for other people to fill</strong>:
         You create a new order which sells ZRX and buys WETH. Another trader might see your
         order and decide to fill it. In this case, you are the <strong>maker</strong> of
        this trade.</li>
      </ul>
    `,
  },

  isPartialFillPossible: {
    title: 'Can an Order by Partially Filled?',
    contents: `
      <p>Yes, you can partially fill an order. For an order selling
        1000 X tokens and buys 2000 Y tokens, you can fill it with Y tokens in any amount no
        more than 2000. For example, you can fill it with 1500 Y tokens and get 750 X tokens.
      </p>
    `,
  },

  feeForCreateOrder: {
    title: 'How Much Transaction Fee Do I Pay When I Create an Order?',
    contents: `
      <p>When you create a new order and submit it to the exchange, you don't need to pay any
      transaction fee. You don't need to pay for Ethereum gas fee either, because there's no
      on-chain transcation at this point. </p>
      <p>However, the exchange might charge a <strong>maker fee</strong>, the amount of which can
      be seen when you review your order before submitting it. If there's a maker fee, the feewill be deducted from your token balance when your order is filled (You only pay partial
      maker fee when the order is partially filled).</p>
      <p>When your order is being filled, the gas
      fee will be paid by the taker, not you (the maker).</p>
    `,
  },

  feeForFillOrder: {
    title: 'How Much Transaction Fee Do I Pay When I Fill an Order?',
    contents: `
      <p>Before you fill an order, you will be able to see whether there's a
      <strong>taker fee</strong> for that order. If the taker fee is non-zero,
      you need to pay the whole taker fee amount if you fill the whole order (you pay partial
      taker fee if you partially fill the order). The taker fee will be automatically deducted
      from your token balance when the trade is complete.</p>
      <p>As a taker, you always need to pay a <strong>protocol fee</strong> (in ETH or WETH) when you fill
      the order. The amount of protocol fee is related to the current gas price. It's calculate as
      150,000 times the gas price per order.</p>
      <p>In addition, you always need to pay for the gas fee when you submit
      your order, just like all other Ethereum on-chain transactions.
      </p>
    `,
  },

}
